import { render, staticRenderFns } from "./TagCol.vue?vue&type=template&id=34746b14"
import script from "./TagCol.vue?vue&type=script&lang=js"
export * from "./TagCol.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports